module.exports = __webpack_public_path__ + "static/img/store-icon3.fa3c874.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/store-icon3.png
// module id = 1yDb
// module chunks = 1